import { memo } from 'react';
import PropTypes from 'prop-types';
import { LazyImage } from 'bv-components';

import GameLink from './components/game_link';
import GameVideo from './components/game_video';
import GamePostMessage from './components/game_post_message';

const GameView = memo(({
  className,
  gameClassName,
  gameTitleClassName,
  imagePath,
  innerComponent: GameInner,
  game,
  category,
  gameSearchCategoryId,
  onImgLoad,
  onImgError,
  scrollableRef,
  isVideoTile,
  callParent,
  parentSessionId,
  isSvgImage,
  largeImage,
}) => {
  const casinoGame = (
    <div className={gameClassName}>
      <div className="casino-game__img">
        <LazyImage
          className="casino-game__bg"
          src={imagePath}
          onLoad={onImgLoad}
          onError={onImgError}
          scrollableRef={scrollableRef}
          withAnimation
          webp={!isSvgImage}
          imageAlt={game.title}
        />
      </div>
      <GameInner game={{ ...game, largeImage }} />
    </div>
  );

  const GameAction = callParent ? GamePostMessage : GameLink;

  return (
    <li className={className}>
      <GameAction
        game={game}
        category={category}
        gameSearchCategoryId={gameSearchCategoryId}
        callParent={callParent}
        parentSessionId={parentSessionId}
      >
        {isVideoTile ? (
          <div className="casino-game-video">
            <GameVideo game={game} scrollableRef={scrollableRef} />
            {casinoGame}
          </div>
        ) : (
          casinoGame
        )}
        <div className={gameTitleClassName}>
          {game.title}
        </div>
      </GameAction>
    </li>
  );
});

GameView.propTypes = {
  className: PropTypes.string,
  gameClassName: PropTypes.string.isRequired,
  gameTitleClassName: PropTypes.string.isRequired,
  imagePath: PropTypes.string.isRequired,
  innerComponent: PropTypes.func.isRequired,
  game: PropTypes.instanceOf(Object).isRequired,
  category: PropTypes.string,
  gameSearchCategoryId: PropTypes.number,
  onImgLoad: PropTypes.func.isRequired,
  onImgError: PropTypes.func.isRequired,
  scrollableRef: PropTypes.instanceOf(Object),
  isVideoTile: PropTypes.bool.isRequired,
  callParent: PropTypes.string.isRequired,
  parentSessionId: PropTypes.string.isRequired,
  isSvgImage: PropTypes.bool.isRequired,
  largeImage: PropTypes.bool.isRequired,
};

GameView.defaultProps = {
  scrollableRef: null,
  gameSearchCategoryId: null,
  className: null,
  category: null,
};

GameView.displayName = 'GameView';

export default GameView;
